/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ product: NonNullable<unknown> }} Product_Empty_TitleInputs */

const en_product_empty_title = /** @type {(inputs: Product_Empty_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No items in ${i?.product} yet`)
};

const de_product_empty_title = /** @type {(inputs: Product_Empty_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Noch keine Vorgänge in ${i?.product}`)
};

/**
* | output |
* | --- |
* | "No items in {product} yet" |
*
* @param {Product_Empty_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const product_empty_title = /** @type {((inputs: Product_Empty_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Empty_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_product_empty_title(inputs)
	return en_product_empty_title(inputs)
});